import { motion } from 'framer-motion';
import { Sparkles, ArrowRight, Rocket, Zap, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';
import Hero3D from '../components/Hero/Hero3D';
import ModulesShowcase from '../components/ModulesShowcase/ModulesShowcase';
import { fadeInUp, staggerContainer } from '../utils/animations';
// import { projectsData } from '../data/projects';

const Home = () => {
  // const featuredProjects = projectsData.filter((p) => p.featured).slice(0, 12);

  const features = [
    {
      icon: Rocket,
      title: 'Innovation First',
      description: 'Pushing the boundaries of what\'s possible with cutting-edge technology',
    },
    {
      icon: Zap,
      title: 'Lightning Fast',
      description: 'Optimized performance for seamless user experiences',
    },
    {
      icon: Globe,
      title: 'Global Scale',
      description: 'Built to handle millions of users worldwide',
    },
  ];

  return (
    <div className="relative">
      {/* Hero Section with 3D Background */}
      <Hero3D />

      {/* Features Section */}
      <section className="relative py-section px-4 sm:px-6 lg:px-8 bg-dark-surface">
        <div className="max-w-7xl mx-auto">
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <motion.h2 variants={fadeInUp} className="text-h2 font-bold mb-4">
              Why Choose <span className="gradient-text">STARZ Tech</span>
            </motion.h2>
            <motion.p variants={fadeInUp} className="text-body-lg text-text-secondary max-w-2xl mx-auto">
              We're redefining the future with innovative solutions that transform industries
            </motion.p>
          </motion.div>

          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 isolate"
          >
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <motion.div
                  key={index}
                  variants={fadeInUp}
                  className="glass-morphism p-8 rounded-2xl group hover:shadow-glow-purple transition-all duration-300"
                >
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-neon-purple to-neon-blue flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <Icon size={28} className="text-white" />
                  </div>
                  <h3 className="text-h4 font-bold mb-2">{feature.title}</h3>
                  <p className="text-text-secondary">{feature.description}</p>
                </motion.div>
              );
            })}
          </motion.div>
        </div>
      </section>

      {/* Modules Showcase Section */}
      <ModulesShowcase />


      {/* CTA Section */}
      <section className="relative py-section px-4 sm:px-6 lg:px-8 bg-dark-surface overflow-hidden">
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="glass-morphism p-12 rounded-3xl"
          >
            <Sparkles size={48} className="text-neon-purple mx-auto mb-6" />
            <h2 className="text-h2 font-bold mb-4">
              Ready to Build the <span className="gradient-text">Future</span>?
            </h2>
            <p className="text-body-lg text-text-secondary mb-8 max-w-2xl mx-auto">
              Join us in creating innovative solutions that transform industries and improve lives
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/projects"
                className="px-8 py-4 bg-gradient-to-r from-neon-purple to-neon-blue text-white font-semibold rounded-xl hover:shadow-glow-purple transition-all duration-300"
              >
                Explore Projects
              </Link>
              <Link
                to="/about"
                className="px-8 py-4 glass-morphism text-text-primary font-semibold rounded-xl hover:border-neon-purple transition-all duration-300"
              >
                Learn More
              </Link>
            </div>
          </motion.div>
        </div>

        {/* Background Decoration */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 -left-1/4 w-96 h-96 bg-neon-purple/10 rounded-full blur-3xl" />
          <div className="absolute bottom-1/4 -right-1/4 w-96 h-96 bg-neon-blue/10 rounded-full blur-3xl" />
        </div>
      </section>
    </div>
  );
};

export default Home;

